<template>
	<module-tab name="已结算" enable-flex @mounted="tabHandle" @activated="$refs.table.update()">
		<m-search ref="search" @search="searchHandle">
			<m-search-item label="结算流水号">
				<c-input name="record_number"></c-input>
			</m-search-item>
			<m-search-item label="订单编号">
				<c-input name="relate_number"></c-input>
			</m-search-item>
			<m-search-item label="生成时间" colspan="2">
				<c-datetime start-name="begin_time" end-name="end_time" range></c-datetime>
			</m-search-item>
			<m-search-item label="结算时间" colspan="2">
				<c-datetime start-name="settled_begin_time" end-name="settled_end_time" range></c-datetime>
			</m-search-item>
		</m-search>
		
		<div class="total flex-wrap">
			<div class="item flex-between-center flex-grow">
				<label>已结算笔数（笔）</label>
				<div>{{settlement.order_count}}</div>
			</div>
			<div class="item flex-between-center flex-grow">
				<label>已结算金额（元）</label>
				<div>{{settlement.record_money}}</div>
			</div>
			<div class="item flex-between-center flex-grow">
				<label>平台综合服务费率</label>
				<div v-if="settlement.fee_ratio">{{parseFloat((parseFloat(settlement.fee_ratio)*100).toFixed(2))}}%</div>
				<div v-else>-</div>
			</div>
		</div>
		
		<m-operate>
			<c-button color="m" hollow @click="syncExport()">导出</c-button>
		</m-operate>
		
		<c-table ref="table" height="grow">
			<c-table-column
				label="结算流水号"
				name="record_number"
				width="120"
			></c-table-column>
			
			<c-table-column
				label="结算类型 "
				name="reward_type"
				width="100"
			>
				<template v-slot="row">
					{{rewardTypeName[row.data.reward_type]}}
				</template>
			</c-table-column>
			
			<c-table-column
				label="订单号"
				name="relate_number"
				width="125"
			></c-table-column>
			
			<c-table-column
				label="订单支付金额"
				name="payment_money"
				width="90"
			>
				<template v-slot="row">
				    <span style="color:green;">¥{{parseFloat(parseFloat(row.data.payment_money).toFixed(2))}}</span>
				</template>
			</c-table-column>
			
			<c-table-column
				label="综合服务费率"
				width="90"
			>
				<template v-slot="row">
					<span style="color:blue;">{{parseFloat(((1-parseFloat(row.data.record_ratio))*100).toFixed(2))}}%</span>
				</template>
			</c-table-column>
			
			<c-table-column
				label="已结算金额"
				name="record_money"
				width="100"
			>
				<template v-slot="row">
				    <span v-if="row.data.state == 2" style="color:green;">
						¥{{parseFloat(parseFloat(row.data.record_money).toFixed(2))}}
					</span>
					<span v-else>-</span>
				</template>
			</c-table-column>
			
			<c-table-column
				label="结算时间"
				name="settlement_date"
				width="140"
			></c-table-column>
			
			<c-table-column
				label="结算状态"
				name="state"
				width="75"
			>
				<template v-slot="{data}">
			        <span v-if="data.state==0" style="color:darkgray">{{transStateName[data.state]}}</span>
			        <span v-if="data.state==1" style="color:#2348d0">{{transStateName[data.state]}}</span>
					<span v-if="data.state==2" style="color:darkgreen">{{transStateName[data.state]}}</span>
				</template>
			</c-table-column>
			
			<c-table-column
				label="结算说明"
				name="remark"
				width="270"
			></c-table-column>
			
			<c-table-column
				label="生成时间"
				name="create_date"
				width="140"
			></c-table-column>
		</c-table>
	</module-tab>
</template>

<script>
export default {
	data() {
		return {
			workType:2,
			searchParams:{},
			settlement: {},
			settle_state:2,	//1=待结算  2=已结算
			transStateName: {
				0: '取消结算',
				1: '待结算',
				2: '已结算'
			},
			rewardTypeName:{
				2: '直推奖励',
				3: '间推奖励',
				201: '爆款代理费',
				202: '专业代理费',
				203: '市代代理费',
				204: '省代代理费',
				205: '业务员代理费',
				206: '平台服务费',
				207: '商家货款'
			},
		}
	},

	methods: {
		tabHandle() {
			this.$refs.search.search();
			this.loadSettlement({});
		},

		searchHandle(data) {
			this.searchParams = Object.assign(data, {
				state: this.settle_state
			});
			this.$refs.table.load({
				url: '/reward/record/list',
				data:this.searchParams
			});
			//加载统计
			this.loadSettlement(data);
		},
		
		loadSettlement(data) {
			this.request({
				url: '/reward/record/total',
				data: Object.assign(data, {
					state: this.settle_state
				}),
				loading: false,  // 是否显示loading，
				success: data => {
				  this.settlement = data;
				  this.public_user_platform_profit_model = data.public_user_platform_profit_model;
				}
			});
		},
		
		/**同步导出数据**/
		syncExport(){
			this.request({
				url: '/export/url',
				data: Object.assign({
					work_type: this.workType //业务类型
				},this.searchParams),
				success: data => {
					this.download({
						fileName: data.filename,
						url: data.url,
						loading: {
							message: '数据文件生成中...'
						}
					})
				}
			});
		}
	}
}
</script>


<style lang="stylus" scoped>
	.total {
		padding: 0 20px 10px;
		
		.item {
			box-sizing: border-box;
			max-width: 300px;
			height: 70px;
			padding: 0 32px 0 30px;
			margin-right: 25px;
			background: #FAF9FC;
			
			label {
				font-size: 14px;
				color: #666;
			}
			
			div {
				font-size: 24px;
				font-weight: bold;
			}
		}
	}
</style>
